import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/lead magnet istock photo.webp")